<template>
    <div>
        <v-dialog
            v-model="display"
            transition
            persistent
            width="500">
            <v-card
                flat>
                <v-card-title>{{ title }}</v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-text-field
                            :label="$t('currency')"
                            hide-details="auto"
                            v-model="form.name"
                            :rules="rules.name">
                        </v-text-field>
                        <v-text-field
                            :label="$t('unit_abbreviation')"
                            hide-details="auto"
                            v-model="form.abbreviation"
                            :rules="rules.abbreviation">
                        </v-text-field>
                        <v-text-field
                            :label="$t('symbol')"
                            hide-details="auto"
                            v-model="form.symbol">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn :loading="loading.submit" :disabled="!valid" @click="submit" text>{{ $t('save_btn') }}</v-btn>
                    <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <SnackbarAlert
            ref="snackbarAlert"/>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import SnackbarAlert from '@/components/common/SnackbarAlert';
import { mapActions, mapState } from 'vuex';
import { v4 as uuid } from 'uuid';

export default {
    name: "CurrencyDialog",
    components: {
        RetryDialog,
        SnackbarAlert
    },
    props: {
        id: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            display: true,
            valid: false,
            loading: {
                data: false,
                submit: false
            },
            idempotentKey: null,
            form: {
                id: null,
                name: null,
                abbreviation: null,
                symbol: null
            },
            rules: {
                name: [
                    v => !!v || this.$t('rules_required')
                ],
                abbreviation: [
                   v => !!v || this.$t('rules_required') 
                ]
            }
        }
    },
    computed: {
        editMode() {
            return !this.notEditMode;
        },
        notEditMode() {
            return !this.id;
        },
        ...mapState('accounting/currency', ["currency"]),
        title() {
            if(this.notEditMode) return this.$t('new_currency');
            else return this.$t('edit_currency')
        }
    },
    methods: {
        ...mapActions('accounting/currency', ["fetchCurrency", "storeCurrency", "updateCurrency"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        async createdDataFetch() {
           
            try {
                this.loading.data = true;
                if(this.editMode) {
                    await this.fetchCurrency(this.id);
                    this.form = this._.clone(this.currency);
                }
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        submit() {
            this.loading.submit = true;
            if(this.notEditMode) {
                this.storeCurrency({...this.form, idempotentKey: this.idempotentKey})
                    .then(() => {
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                        this.close();
                        this.$emit('submit');
                    }).catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error.message;
                        this.setSnackBars({color: "error", message});
                    })
            } else {
                this.updateCurrency(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                       this.setSnackBars({color: "error", message});
                    })
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        close() {
            this.$emit('close');
        }
    },
    created () {
        this.createdDataFetch();
        this.idempotentKey = uuid()
    },
}
</script>